import React, { useCallback, useEffect, useState } from "react";
import { Box, Text } from "grommet";
import { useAuth } from "../../context";
import { getAllAudit } from "../../api/funderAllocation";
import { AuditLogTable } from "./AuditLogTable";
import { Panel } from "./Panel";

// Every Funder Allocation audit event, independent of whether the record
// it refers to still exists - a hard-deleted record has no detail page of
// its own for an audit tab to live on, so this is the only place that
// history remains visible.
const GlobalAuditSection = () => {
    const { tokens } = useAuth();
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        if (!tokens?.idToken) return;
        setLoading(true);
        setError(null);
        try {
            const data = await getAllAudit(tokens.idToken);
            setEntries(data || []);
        } catch (e) {
            setError(e?.response?.data?.detail || "Failed to load audit log");
        } finally {
            setLoading(false);
        }
    }, [tokens]);

    useEffect(() => {
        load();
    }, [load]);

    return (
        <Box gap="medium">
            {error && <Text color="status-critical">{error}</Text>}
            <Panel>
                <Text weight="bold" size="large">
                    Audit Log
                </Text>
                <Text size="small" color="dark-5">
                    Every funder, loan, and allocation change, including records
                    that have since been permanently deleted.
                </Text>
                <AuditLogTable loading={loading} entries={entries} />
            </Panel>
        </Box>
    );
};

export { GlobalAuditSection };
